import React, { ChangeEvent, useState } from "react";
import { useCombinedStore } from "../store";
import Modal from "react-modal";
import MessageBox from "./MessageBox";
import employeesIcon from "../assets/employees.svg";
import settingsIcon from "../assets/settings.svg";
import alfredoIcon from "../assets/alfredo-icon.svg";
import api from "../services/api.service";
import { carregarConfigDoPdv } from "../services/pdvConfig.service";
import * as Styles from "../styles/Main.styles";
import PeriodContent from "./PeriodContent";
import { set } from "date-fns";

interface CheckboxProps {
  checked: boolean;
  onClick: () => void;
}
const Checkbox: React.FC<CheckboxProps> = ({ checked, onClick }) => {
  const { subsidiaryDataZustand } = useCombinedStore();
  return (
    <Styles.CheckboxContainer>
      <Styles.SwitchLabel>
        <Styles.SwitchInput
          type="checkbox"
          checked={checked}
          onClick={onClick}
          aria-checked={checked}
        />
        <Styles.Slider
          className={checked ? "checked" : ""}
          color={
            subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
              .buttonsColor
          }
        >
          <Styles.SliderThumb className={checked ? "checked" : ""} />
        </Styles.Slider>
      </Styles.SwitchLabel>
    </Styles.CheckboxContainer>
  );
};

const MainModal: React.FC<{
  isOpen: boolean;
  onRequestClose: () => void;
}> = ({ isOpen, onRequestClose }) => {
  const {
    authUserZustand,
    setSubsidiaryDataZustand,
    subsidiaryDataZustand,
    setMessageZustand,
    removeMessageZustand,
    selectedSectionZustand,
    setSelectedSectionZustand,
  } = useCombinedStore();
  const [backgroundColor, setBackgroundColor] = useState("");
  const [buttonsColor, setButtonsColor] = useState("");
  const [textColor, setTextColor] = useState("");

  const handleChangeSelectedPDV = async (pdvUuid: string) => {
    try {
      // O mapeamento saiu daqui para services/pdvConfig.service.ts: a mesma
      // leitura é usada pelo hook que reconsulta a configuração enquanto o PDV
      // está aberto (useConfigDoPdv), quando a Central manda alteração.
      const config = await carregarConfigDoPdv(pdvUuid);
      const updatedSelectedPDV = subsidiaryDataZustand.pdvs?.find(
        (pdv: any) => pdv.itemUuid === pdvUuid
      );

      setSubsidiaryDataZustand({
        ...subsidiaryDataZustand,
        selectedPdv: {
          ...subsidiaryDataZustand.selectedPdv,
          itemUuid: updatedSelectedPDV?.itemUuid || "",
          itemName: updatedSelectedPDV?.itemName || "",
          itemLogoUrl: updatedSelectedPDV?.itemLogoUrl || "",
          homeInfo: config.homeInfo,
          lastPeriod: config.lastPeriod,
          selectedPeriod: config.selectedPeriod,
          saleOptions: config.saleOptions,
          printers: config.printers,
          configVersao: config.configVersao,
          configPendente: config.configPendente,
        },
      });
    } catch (error: any) {
      setMessageZustand(error.message, "error");
    }
  };
  const handleUpdatePDVFile =
    (fileName: string, saleOptionUuid?: string) => async () => {
      try {
        const fileInput = document.createElement("input");
        fileInput.type = "file";
        fileInput.accept = "image/*";
        fileInput.click();

        fileInput.addEventListener("change", async (e) => {
          const selectedFile = (e.target as HTMLInputElement).files?.[0];
          if (selectedFile) {
            const reader = new FileReader();

            reader.onload = async (event) => {
              if (event.target) {
                const fileBase64 = event.target.result as string;
                await pdvFileChange(fileName, fileBase64, saleOptionUuid)();
              }
            };

            reader.readAsDataURL(selectedFile);
          }
        });
      } catch (error) {
        console.error("Error selecting file:", error);
      }
    };
  const pdvFileChange =
    (fileName: string, fileBase64: string, saleOptionUuid?: string) =>
      async () => {
        if (fileName === "homeInfo.itemInfoValue.logo") {
          const updatedSelectedPDV = {
            ...subsidiaryDataZustand.selectedPdv,
            homeInfo: {
              ...subsidiaryDataZustand.selectedPdv.homeInfo,
              itemInfoValue: {
                ...subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue,
                logo: fileBase64,
              },
            },
          };
          setSubsidiaryDataZustand({
            ...subsidiaryDataZustand,
            selectedPdv: updatedSelectedPDV,
          });
        } else if (fileName.includes("sale_option_")) {
          const updatedSaleOptions =
            subsidiaryDataZustand.selectedPdv.saleOptions.map(
              (saleOption: any) => {
                if (saleOption.itemInfoUuid === saleOptionUuid) {
                  return {
                    ...saleOption,
                    itemInfoValue: {
                      ...saleOption.itemInfoValue,
                      saleOptionImg: fileBase64,
                    },
                  };
                }
                return saleOption;
              }
            );
          setSubsidiaryDataZustand({
            ...subsidiaryDataZustand,
            selectedPdv: {
              ...subsidiaryDataZustand.selectedPdv,
              saleOptions: updatedSaleOptions,
            },
          });
        }
      };

  const handlePDVInfoChange =
    (fieldName: string, saleOptionUuid?: string) =>
      (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any,
      ) => {
        if (fieldName.includes("homeInfo.itemInfoValue")) {
          const updatedSelectedPDV = {
            ...subsidiaryDataZustand.selectedPdv,
            homeInfo: {
              ...subsidiaryDataZustand.selectedPdv.homeInfo,
              itemInfoValue: {
                ...subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue,
                [fieldName.replace("homeInfo.itemInfoValue.", "")]:
                  e.target.value,
              },
            },
          };
          setSubsidiaryDataZustand({
            ...subsidiaryDataZustand,
            selectedPdv: updatedSelectedPDV,
          });
        } else if (fieldName.includes("saleOption")) {
          const updatedSaleOptions =
            subsidiaryDataZustand.selectedPdv.saleOptions.map(
              (saleOption: any) => {
                if (saleOption.itemInfoUuid === saleOptionUuid) {
                  return {
                    ...saleOption,
                    itemInfoValue: {
                      ...saleOption.itemInfoValue,
                      [fieldName.replace("saleOption.", "")]: e.target.value,
                    },
                  };
                }
                return saleOption;
              }
            );
          setSubsidiaryDataZustand({
            ...subsidiaryDataZustand,
            selectedPdv: {
              ...subsidiaryDataZustand.selectedPdv,
              saleOptions: updatedSaleOptions,
            },
          });
        }
      };

  const handlePDVBooleanInfoChange = (fieldName: string) => () => {
    const updatedSelectedPDV = {
      ...subsidiaryDataZustand.selectedPdv,
      homeInfo: {
        ...subsidiaryDataZustand.selectedPdv.homeInfo,
        itemInfoValue: {
          ...subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue,
          [fieldName]:
            !subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue[
            fieldName as keyof typeof subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
            ],
        },
      },
    };
    setSubsidiaryDataZustand({
      ...subsidiaryDataZustand,
      selectedPdv: updatedSelectedPDV,
    });
  };

  const handleSaleOptionBooleanInfoChange =
    (saleOptionUuid: string, fieldName: string) => () => {
      const updatedSaleOptions = (
        subsidiaryDataZustand.selectedPdv.saleOptions || []
      ).map((saleOption: any) => {
        if (saleOption.itemInfoUuid === saleOptionUuid) {
          return {
            ...saleOption,
            [fieldName]: !saleOption[fieldName],
          };
        }
        return saleOption;
      });
      setSubsidiaryDataZustand({
        ...subsidiaryDataZustand,
        selectedPdv: {
          ...subsidiaryDataZustand.selectedPdv,
          saleOptions: updatedSaleOptions,
        },
      });
    };
  const handleProportionLogoChange = (e: ChangeEvent<HTMLInputElement>) => {
    const proportion = parseInt(e.target.value, 10);
    const newValue = proportion.toString() + "px";
    const updatedSelectedPDV = {
      ...subsidiaryDataZustand.selectedPdv,
      homeInfo: {
        ...subsidiaryDataZustand.selectedPdv.homeInfo,
        itemInfoValue: {
          ...subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue,
          logoWidth: newValue,
          logoHeight: newValue,
        },
      },
    };
    setSubsidiaryDataZustand({
      ...subsidiaryDataZustand,
      selectedPdv: updatedSelectedPDV,
    });
  };

  const handleProportionButtonsChange = (e: ChangeEvent<HTMLInputElement>) => {
    const proportion = parseInt(e.target.value, 10);
    const newValue = proportion.toString() + "px";
    const updatedSelectedPDV = {
      ...subsidiaryDataZustand.selectedPdv,
      homeInfo: {
        ...subsidiaryDataZustand.selectedPdv.homeInfo,
        itemInfoValue: {
          ...subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue,
          buttonsWidth: newValue,
          buttonsHeight: newValue,
        },
      },
    };
    setSubsidiaryDataZustand({
      ...subsidiaryDataZustand,
      selectedPdv: updatedSelectedPDV,
    });
  };
  const handleApiUrlChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSubsidiaryDataZustand({
      ...subsidiaryDataZustand,
      subsidiaryVirtualAddress: e.target.value,
    });
  };

  const handleCloseModal = () => {
    if (subsidiaryDataZustand.selectedPdv.selectedPeriod) {
      setSelectedSectionZustand("Periodo");
    } else {
      setSelectedSectionZustand("Parametrizacoes");
    }
    onRequestClose();
  };

  const getDimension = (dimensionName: string) => {
    const homeInfo = subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue;
    const dimensionValue = homeInfo[dimensionName as keyof typeof homeInfo];

    if (typeof dimensionValue === "string") {
      const dimensionNumericValue = parseInt(
        dimensionValue.replace("px", ""),
        10
      );
      return dimensionNumericValue;
    }

    // Caso dimensionValue não seja uma string, retorne um valor padrão ou faça outra tratativa
    return 0; // Valor padrão
  };

  const renderContent = () => {
    switch (selectedSectionZustand as string) {
      case "Periodo":
        return <PeriodContent />;
      case "Colaboradores":
        return (
          <Styles.MainModalEmployeesContent>
            <Styles.MainModalEmployeesLogo src={employeesIcon} />
            <h3>Disponibilidade do Time</h3>
            <table>
              <thead>
                <tr>
                  <th>Equipe</th>
                  <th>Nome</th>
                  <th>Status</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Equipe 1</td>
                  <td>Nome 1</td>
                  <td>Disponível</td>
                  <td>Editar</td>
                </tr>
                {/* Outras linhas da tabela */}
              </tbody>
            </table>
          </Styles.MainModalEmployeesContent>
        );
      case "Parametrizacoes":
        return (
          <Styles.MainModalSettingsContent>
            <Styles.MainModalSettingsLogo src={settingsIcon} />
            <Styles.ContainerTitle>
              Selecione o Caixa utilizado neste dispositivo:
            </Styles.ContainerTitle>
            <Styles.CaixaContainer
              color={
                subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                  .buttonsColor
              }
            >
              <link
                href="https://fonts.googleapis.com/icon?family=Material+Icons"
                rel="stylesheet"
              />
              <Styles.StatusIndicator
                status={
                  subsidiaryDataZustand.selectedPdv.selectedPeriod
                    ? "Aberto"
                    : "Fechado"
                }
              />
              <Styles.StatusIndicatorText>
                {subsidiaryDataZustand.selectedPdv.selectedPeriod
                  ? "Período Aberto"
                  : "Período Fechado"}
              </Styles.StatusIndicatorText>
              {subsidiaryDataZustand.pdvs?.map((pdv: any) => (
                <Styles.Caixa key={pdv.itemUuid}>
                  {pdv.itemLogoUrl ? (
                    <Styles.CaixaImage
                      selected={
                        subsidiaryDataZustand.selectedPdv.itemUuid ===
                        pdv.itemUuid
                      }
                      src={pdv.itemLogoUrl}
                      onClick={() => handleChangeSelectedPDV(pdv.itemUuid)}
                      color={
                        subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                          .buttonsColor
                      }
                    />
                  ) : (
                    <Styles.CaixaIcon
                      onClick={() => handleChangeSelectedPDV(pdv.itemUuid)}
                      selected={
                        subsidiaryDataZustand.selectedPdv.itemUuid ===
                        pdv.itemUuid
                      }
                      color={
                        subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                          .buttonsColor
                      }
                    >
                      point_of_sales
                    </Styles.CaixaIcon>
                  )}
                  <Styles.CaixaName
                    selected={
                      subsidiaryDataZustand.selectedPdv.itemUuid ===
                      pdv.itemUuid
                    }
                    onClick={() => handleChangeSelectedPDV(pdv.itemUuid)}
                    color={
                      subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                        .buttonsColor
                    }
                  >
                    {pdv.itemName}
                  </Styles.CaixaName>
                </Styles.Caixa>
              ))}
            </Styles.CaixaContainer>
            {subsidiaryDataZustand.selectedPdv.itemUuid ? (
              <Styles.SelectedPDVInfo>
                <Styles.ContainerTitle>
                  Configurações do Caixa:
                </Styles.ContainerTitle>
                <Styles.ConfigContainer
                  color={
                    subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                      .buttonsColor
                  }
                >
                  <Styles.RowContainer>
                    <Styles.FieldContainer>
                      <Styles.FieldLabel>
                        Endereço virtual da API:
                      </Styles.FieldLabel>
                      <Styles.TextInput
                        color={
                          subsidiaryDataZustand.selectedPdv.homeInfo
                            .itemInfoValue.buttonsColor
                        }
                      >
                        <input
                          type="text"
                          placeholder=""
                          value={subsidiaryDataZustand.subsidiaryVirtualAddress}
                          onChange={handleApiUrlChange}
                        />
                        <label>Endereço virtual da API:</label>
                      </Styles.TextInput>
                    </Styles.FieldContainer>
                  </Styles.RowContainer>
                  <Styles.RowContainer>
                    <Styles.FieldContainer>
                      <Checkbox
                        checked={
                          subsidiaryDataZustand.selectedPdv.homeInfo
                            .itemInfoValue.askInitialCashBalance
                        }
                        onClick={handlePDVBooleanInfoChange(
                          "askInitialCashBalance"
                        )}
                      />
                    </Styles.FieldContainer>
                    <Styles.FieldLabel>
                      Informar fundo de caixa ao inciar o período?
                    </Styles.FieldLabel>
                    <Styles.FieldContainer>
                      <Styles.NumberInput
                        color={
                          subsidiaryDataZustand.selectedPdv.homeInfo
                            .itemInfoValue.buttonsColor
                        }
                      >
                        <input
                          type="number"
                          placeholder=""
                          value={
                            subsidiaryDataZustand.selectedPdv.homeInfo
                              .itemInfoValue.initialCashBalance
                          }
                          onChange={handlePDVInfoChange(
                            "homeInfo.itemInfoValue.initialCashBalance"
                          )}
                        />
                        <label>Fundo de Caixa:</label>
                      </Styles.NumberInput>
                      <Styles.Unit
                        color={
                          subsidiaryDataZustand.selectedPdv.homeInfo
                            .itemInfoValue.buttonsColor
                        }
                      >
                        R$
                      </Styles.Unit>
                    </Styles.FieldContainer>
                  </Styles.RowContainer>
                  <Styles.RowContainer>
                    <Styles.FieldContainer>
                      <Checkbox
                        checked={false}
                        onClick={() => { }}
                      // {
                      //   subsidiaryDataZustand.selectedPdv.homeInfo
                      //     .itemInfoValue.askInitialCashBalance
                      // }
                      // onClick={handlePDVBooleanInfoChange(
                      //   "askInitialCashBalance"
                      // )}
                      />
                    </Styles.FieldContainer>
                    <Styles.FieldLabel>
                      Abrir período Ifood ao inciar o período?
                    </Styles.FieldLabel>
                    <Styles.FieldContainer>
                      <Styles.TextInput
                        color={
                          subsidiaryDataZustand.selectedPdv.homeInfo
                            .itemInfoValue.buttonsColor
                        }
                      >
                        <input
                          type="text"
                          placeholder=""
                          value={"366cc638-57da-11ee-8c99-0242ac120002"}
                          onChange={handlePDVInfoChange("initialCashBalance")}
                        />
                        <label>Client ID</label>
                      </Styles.TextInput>
                    </Styles.FieldContainer>
                  </Styles.RowContainer>
                </Styles.ConfigContainer>
                <Styles.ContainerTitle>
                  Personalize o Caixa:
                </Styles.ContainerTitle>
                <Styles.CustomizeContainer
                  color={
                    subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                      .buttonsColor
                  }
                >
                  <Styles.RowContainer>
                    <Styles.FileInputContainer>
                      <Styles.FileInputLabel
                        color={
                          subsidiaryDataZustand.selectedPdv.homeInfo
                            .itemInfoValue.buttonsColor
                        }
                      >
                        Alterar imagem
                      </Styles.FileInputLabel>
                      <Styles.FileInput
                        type="file"
                        accept="image/*"
                        onChange={handleUpdatePDVFile(
                          "homeInfo.itemInfoValue.logo"
                        )}
                      />
                      <Styles.StyledIcon
                        color={
                          subsidiaryDataZustand.selectedPdv.homeInfo
                            .itemInfoValue.buttonsColor
                        }
                      >
                        add_photo_alternate
                      </Styles.StyledIcon>
                    </Styles.FileInputContainer>
                    <Styles.FieldLabel>Tamanho do logo:</Styles.FieldLabel>
                    <Styles.FieldContainer>
                      <Styles.NumberInput
                        color={
                          subsidiaryDataZustand.selectedPdv.homeInfo
                            .itemInfoValue.buttonsColor
                        }
                      >
                        <input
                          type="number"
                          value={getDimension("logoHeight")}
                          onChange={handlePDVInfoChange("logoHeight")}
                        />
                        <label>Altura:</label>
                      </Styles.NumberInput>
                      <Styles.Unit
                        color={
                          subsidiaryDataZustand.selectedPdv.homeInfo
                            .itemInfoValue.buttonsColor
                        }
                      >
                        px
                      </Styles.Unit>
                    </Styles.FieldContainer>
                    <Styles.Separator
                      color={
                        subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                          .buttonsColor
                      }
                    >
                      x
                    </Styles.Separator>
                    <Styles.FieldContainer>
                      <Styles.NumberInput
                        color={
                          subsidiaryDataZustand.selectedPdv.homeInfo
                            .itemInfoValue.buttonsColor
                        }
                      >
                        <input
                          type="number"
                          value={getDimension("logoWidth")}
                          onChange={handlePDVInfoChange("logoWidth")}
                        />
                        <label>Largura:</label>
                      </Styles.NumberInput>
                      <Styles.Unit
                        color={
                          subsidiaryDataZustand.selectedPdv.homeInfo
                            .itemInfoValue.buttonsColor
                        }
                      >
                        px
                      </Styles.Unit>
                    </Styles.FieldContainer>
                    <Styles.FieldContainer>
                      <Styles.ProportionSlider
                        type="range"
                        min="50"
                        max={500}
                        step={1}
                        value={getDimension("logoHeight")}
                        onChange={handleProportionLogoChange}
                        color={
                          subsidiaryDataZustand.selectedPdv.homeInfo
                            .itemInfoValue.buttonsColor
                        }
                      />
                    </Styles.FieldContainer>
                  </Styles.RowContainer>
                  <Styles.RowContainer>
                    <Styles.FieldContainer>
                      <Styles.FieldLabel>
                        Título da Tela Inicial:
                      </Styles.FieldLabel>
                      <Styles.TextInput
                        color={
                          subsidiaryDataZustand.selectedPdv.homeInfo
                            .itemInfoValue.buttonsColor
                        }
                      >
                        <input
                          type="text"
                          placeholder=""
                          value={
                            subsidiaryDataZustand.selectedPdv.homeInfo
                              .itemInfoValue.homeTitle
                          }
                          onChange={handlePDVInfoChange(
                            "homeInfo.itemInfoValue.homeTitle"
                          )}
                        />
                        <label>Título da Tela Inicial:</label>
                      </Styles.TextInput>
                    </Styles.FieldContainer>
                  </Styles.RowContainer>
                  <Styles.RowContainer>
                    <Styles.FieldContainer>
                      <Styles.FieldLabel>
                        Impressora padrão:
                      </Styles.FieldLabel>
                      <Styles.DropdownInput
                        color={
                          subsidiaryDataZustand.selectedPdv.homeInfo
                            .itemInfoValue.buttonsColor
                        }
                      >
                        <select
                          value={subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue.defaultPrinterAddress}
                          onChange={handlePDVInfoChange(
                            "homeInfo.itemInfoValue.defaultPrinterAddress"
                          )}
                        >
                          {Array.isArray(subsidiaryDataZustand.selectedPdv.printers) && subsidiaryDataZustand.selectedPdv.printers.map((printer: any) => (
                            <option key={printer.printerUuid} value={printer.printerIp}>
                              {printer.printerName}
                            </option>
                          ))}
                        </select>
                        <label>Impressora</label>
                      </Styles.DropdownInput>
                    </Styles.FieldContainer>
                  </Styles.RowContainer>
                  <Styles.ContainerTitle>
                    Ajuste as opções de venda utilizadas neste caixa:
                  </Styles.ContainerTitle>
                  {subsidiaryDataZustand.selectedPdv.saleOptions?.map(
                    (option, index) => {
                      const optionFieldName = `sale_option_${index + 1}`;
                      return (
                        <Styles.RowContainer key={index}>
                          <Styles.FieldLabel>
                            {option.itemInfoStatus === true
                              ? "Habilitado"
                              : "Desabilitado"}
                          </Styles.FieldLabel>
                          <Checkbox
                            checked={option.itemInfoStatus}
                            onClick={handleSaleOptionBooleanInfoChange(
                              option.itemInfoUuid,
                              "itemInfoStatus"
                            )}
                          />
                          <Styles.TextInput
                            color={
                              subsidiaryDataZustand.selectedPdv.homeInfo
                                .itemInfoValue.buttonsColor
                            }
                          >
                            <input
                              type="text"
                              placeholder=""
                              value={option.itemInfoValue.saleOptionName}
                              onChange={handlePDVInfoChange(
                                "saleOption.saleOptionName",
                                option.itemInfoUuid
                              )}
                            />
                            <label>Nome da Opção</label>
                          </Styles.TextInput>
                          <Styles.FileInputContainer>
                            <Styles.FileInputLabel
                              color={
                                subsidiaryDataZustand.selectedPdv.homeInfo
                                  .itemInfoValue.buttonsColor
                              }
                            >
                              Alterar imagem
                            </Styles.FileInputLabel>
                            <Styles.FileInput
                              type="file"
                              accept="image/*"
                              onChange={handleUpdatePDVFile(
                                optionFieldName,
                                option.itemInfoUuid
                              )}
                            />
                            <Styles.StyledIcon
                              color={
                                subsidiaryDataZustand.selectedPdv.homeInfo
                                  .itemInfoValue.buttonsColor
                              }
                            >
                              add_photo_alternate
                            </Styles.StyledIcon>
                          </Styles.FileInputContainer>
                          <Styles.DropdownInput
                            color={
                              subsidiaryDataZustand.selectedPdv.homeInfo
                                .itemInfoValue.buttonsColor
                            }
                          >
                            <select>
                              <option value="opcao1">Opção 1</option>
                              <option value="opcao2">Opção 2</option>
                              <option value="opcao3">Opção 3</option>
                            </select>
                            <label>Tipo de Opção</label>
                          </Styles.DropdownInput>
                        </Styles.RowContainer>
                      );
                    }
                  )}

                  <Styles.RowContainer>
                    <Styles.FieldLabel>Tamanho dos botões:</Styles.FieldLabel>
                    <Styles.FieldContainer>
                      <Styles.NumberInput
                        color={
                          subsidiaryDataZustand.selectedPdv.homeInfo
                            .itemInfoValue.buttonsColor
                        }
                      >
                        <input
                          type="number"
                          value={getDimension("buttonsHeight")}
                          onChange={handlePDVInfoChange("buttonsHeight")}
                        />
                        <label>Altura:</label>
                      </Styles.NumberInput>
                      <Styles.Unit
                        color={
                          subsidiaryDataZustand.selectedPdv.homeInfo
                            .itemInfoValue.buttonsColor
                        }
                      >
                        %
                      </Styles.Unit>
                    </Styles.FieldContainer>
                    <Styles.Separator
                      color={
                        subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                          .buttonsColor
                      }
                    >
                      x
                    </Styles.Separator>
                    <Styles.FieldContainer>
                      <Styles.NumberInput
                        color={
                          subsidiaryDataZustand.selectedPdv.homeInfo
                            .itemInfoValue.buttonsColor
                        }
                      >
                        <input
                          type="number"
                          value={getDimension("buttonsWidth")}
                          onChange={handlePDVInfoChange("buttonsWidth")}
                        />
                        <label>Largura:</label>
                      </Styles.NumberInput>
                      <Styles.Unit
                        color={
                          subsidiaryDataZustand.selectedPdv.homeInfo
                            .itemInfoValue.buttonsColor
                        }
                      >
                        %
                      </Styles.Unit>
                    </Styles.FieldContainer>
                    <Styles.FieldContainer>
                      <Styles.ProportionSlider
                        type="range"
                        min="5"
                        max={500}
                        step={1}
                        value={getDimension("buttonsHeight")}
                        onChange={handleProportionButtonsChange}
                        color={
                          subsidiaryDataZustand.selectedPdv.homeInfo
                            .itemInfoValue.buttonsColor
                        }
                      />
                    </Styles.FieldContainer>
                  </Styles.RowContainer>
                  <Styles.RowContainer>
                    <Styles.FieldLabel>
                      Ajuste as cores do caixa:
                    </Styles.FieldLabel>
                    <Styles.FieldContainer>
                      <Styles.CirclePreview color={backgroundColor}>
                        <input
                          type="color"
                          value={backgroundColor}
                          onChange={(e) => setBackgroundColor(e.target.value)}
                          onBlur={handlePDVInfoChange(
                            "homeInfo.itemInfoValue.backgroundColor"
                          )}
                        />
                      </Styles.CirclePreview>
                    </Styles.FieldContainer>
                    <Styles.FieldContainer>
                      <Styles.FieldLabel>Fundo</Styles.FieldLabel>
                      <Styles.CirclePreview color={buttonsColor}>
                        <input
                          type="color"
                          value={buttonsColor}
                          onChange={(e) => setButtonsColor(e.target.value)}
                          onBlur={handlePDVInfoChange(
                            "homeInfo.itemInfoValue.buttonsColor"
                          )}
                        />
                      </Styles.CirclePreview>
                    </Styles.FieldContainer>
                    <Styles.FieldContainer>
                      <Styles.FieldLabel>Botões</Styles.FieldLabel>
                      <Styles.CirclePreview color={textColor}>
                        <input
                          type="color"
                          value={textColor}
                          onChange={(e) => setTextColor(e.target.value)}
                          onBlur={handlePDVInfoChange(
                            "homeInfo.itemInfoValue.textColor"
                          )}
                        />
                      </Styles.CirclePreview>
                      <Styles.FieldLabel>Texto</Styles.FieldLabel>
                    </Styles.FieldContainer>
                  </Styles.RowContainer>
                </Styles.CustomizeContainer>
              </Styles.SelectedPDVInfo>
            ) : null}
          </Styles.MainModalSettingsContent>
        );
      default:
        return null;
    }
  };
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={Styles.customStyles}
      contentLabel="Main Modal"
      ariaHideApp={false}
    >
      <Styles.ModalWrapper>
        <Styles.CloseButton onClick={handleCloseModal}>
          &times;
        </Styles.CloseButton>
        <Styles.ModalContent>
          <Styles.Logo src={alfredoIcon} alt="Alfredo Web OPS" />
          <Styles.SectionNavigation>
            <Styles.SectionButton
              onClick={() => setSelectedSectionZustand("Periodo")}
              selected={
                selectedSectionZustand?.toString() === "Periodo" ? true : false
              }
              color={
                subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                  .buttonsColor
              }
              disabled={subsidiaryDataZustand.selectedPdv.itemUuid === ""}
            >
              Período
            </Styles.SectionButton>
            <Styles.SectionButton
              onClick={() => setSelectedSectionZustand("Colaboradores")}
              selected={
                selectedSectionZustand?.toString() === "Colaboradores"
                  ? true
                  : false
              }
              color={
                subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                  .buttonsColor
              }
              disabled={subsidiaryDataZustand.selectedPdv.itemUuid === ""}
            >
              Colaboradores
            </Styles.SectionButton>
            {authUserZustand?.userInfo.userGroupType === 1 ? (
              <Styles.SectionButton
                onClick={() => setSelectedSectionZustand("Parametrizacoes")}
                selected={
                  selectedSectionZustand?.toString() === "Parametrizacoes"
                    ? true
                    : false
                }
                color={
                  subsidiaryDataZustand.selectedPdv.homeInfo.itemInfoValue
                    .buttonsColor
                }
              >
                Parametrizações
              </Styles.SectionButton>
            ) : null}
          </Styles.SectionNavigation>
          {renderContent()}
        </Styles.ModalContent>
      </Styles.ModalWrapper>
    </Modal>
  );
};
export default MainModal;
